// extracted by mini-css-extract-plugin
export var loadingSpinner = "_2n-0";
export var spinnerContainer = "_2n-1";